import { BaseInformationDialog } from '@certara/common-react-components';
import { useUIStore } from '@/stores/ui-store';

export function InformationDialog() {
  const open = useUIStore((state) => state.infoDialogOpen);
  const setOpen = useUIStore((state) => state.setInfoDialogOpen);

  return (
    <BaseInformationDialog
      open={open}
      onClose={() => setOpen(false)}
      appName="Load"
      version={window.version}
    />
  );
}
